export default __webpack_public_path__ + "static/media/020_start_moreInfo.fe4ba8bc.mp3";